module.exports = __webpack_public_path__ + "static/media/fg_3l.737ec002.png";